import { render, staticRenderFns } from "./customer_portal.vue?vue&type=template&id=0a7b154f&scoped=true&"
import script from "./customer_portal.vue?vue&type=script&lang=js&"
export * from "./customer_portal.vue?vue&type=script&lang=js&"
import style0 from "./customer_portal.vue?vue&type=style&index=0&id=0a7b154f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b154f",
  null
  
)

export default component.exports